module.exports = __webpack_public_path__ + "img/quick_sell.9c503f32.svg";